import React, { useState } from 'react';
import styled from 'styled-components';

const BUTTONS = [
    ['MC', 'MR', 'MS', 'M+'],
    ['7', '8', '9', '/', 'sqrt'],
    ['4', '5', '6', '*', '%'],
    ['1', '2', '3', '-', '1/x'],
    ['0', '+/-', '.', '+', '='],
];

function Calculator() {
    const [display, setDisplay] = useState('0.');
    const [memory, setMemory] = useState(0);
    const [current, setCurrent] = useState(0);
    const [operator, setOperator] = useState(null);
    const [newNumber, setNewNumber] = useState(true);

    function handleButton(btn) {
        if (btn >= '0' && btn <= '9') {
            if (newNumber) {
                setDisplay(btn + '.');
                setNewNumber(false);
            } else {
                setDisplay(prev => {
                    const clean = prev.endsWith('.') && !prev.includes('.', 0, prev.length - 1) ? prev.slice(0, -1) : prev;
                    return (clean === '0' ? btn : clean + btn) + '.';
                });
            }
        } else if (btn === '.') {
            if (newNumber) {
                setDisplay('0.');
                setNewNumber(false);
            }
        } else if (btn === '+/-') {
            setDisplay(prev => {
                const num = parseFloat(prev);
                return (-num).toString() + '.';
            });
        } else if (btn === 'C' || btn === 'CE') {
            setDisplay('0.');
            setCurrent(0);
            setOperator(null);
            setNewNumber(true);
        } else if (btn === 'Back') {
            setDisplay(prev => {
                const clean = prev.endsWith('.') ? prev.slice(0, -1) : prev;
                if (clean.length <= 1) return '0.';
                return clean.slice(0, -1) + '.';
            });
        } else if (['+', '-', '*', '/'].includes(btn)) {
            const num = parseFloat(display);
            if (operator && !newNumber) {
                const result = calculate(current, num, operator);
                setCurrent(result);
                setDisplay(result.toString() + '.');
            } else {
                setCurrent(num);
            }
            setOperator(btn);
            setNewNumber(true);
        } else if (btn === '=') {
            if (operator) {
                const num = parseFloat(display);
                const result = calculate(current, num, operator);
                setDisplay(result.toString() + '.');
                setCurrent(result);
                setOperator(null);
                setNewNumber(true);
            }
        } else if (btn === 'sqrt') {
            const num = parseFloat(display);
            setDisplay(Math.sqrt(num).toString() + '.');
            setNewNumber(true);
        } else if (btn === '%') {
            const num = parseFloat(display);
            setDisplay((current * num / 100).toString() + '.');
            setNewNumber(true);
        } else if (btn === '1/x') {
            const num = parseFloat(display);
            if (num === 0) {
                setDisplay('Cannot divide by zero');
            } else {
                setDisplay((1 / num).toString() + '.');
            }
            setNewNumber(true);
        } else if (btn === 'MC') { setMemory(0); }
        else if (btn === 'MR') { setDisplay(memory.toString() + '.'); setNewNumber(true); }
        else if (btn === 'MS') { setMemory(parseFloat(display)); }
        else if (btn === 'M+') { setMemory(memory + parseFloat(display)); }
    }

    function calculate(a, b, op) {
        switch (op) {
            case '+': return a + b;
            case '-': return a - b;
            case '*': return a * b;
            case '/': return b !== 0 ? a / b : 0;
            default: return b;
        }
    }

    return (
        <Container>
            <div className="calc__menu">
                <span className="calc__menu__item">Edit</span>
                <span className="calc__menu__item">View</span>
                <span className="calc__menu__item">Help</span>
            </div>
            <div className="calc__display">{display}</div>
            <div className="calc__top__row">
                <button className="calc__btn calc__btn--wide" onClick={() => handleButton('Back')}>Backspace</button>
                <button className="calc__btn calc__btn--wide" onClick={() => handleButton('CE')}>CE</button>
                <button className="calc__btn calc__btn--wide" onClick={() => handleButton('C')}>C</button>
            </div>
            {BUTTONS.map((row, i) => (
                <div key={i} className="calc__row">
                    {row.map(btn => (
                        <button
                            key={btn}
                            className={`calc__btn ${btn >= '0' && btn <= '9' || btn === '.' || btn === '+/-' ? 'calc__btn--num' : 'calc__btn--op'}`}
                            onClick={() => handleButton(btn)}
                        >
                            {btn}
                        </button>
                    ))}
                </div>
            ))}
        </Container>
    );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ece9d8;
  font-family: Tahoma, sans-serif;
  padding: 2px;

  .calc__menu {
    display: flex;
    gap: 0;
    padding: 2px 4px;
    border-bottom: 1px solid #aaa;
    margin-bottom: 4px;
  }
  .calc__menu__item {
    padding: 2px 10px;
    font-size: 11px;
    cursor: pointer;
    &:hover { background: #316ac5; color: #fff; }
  }

  .calc__display {
    background: #fff;
    border: 2px inset #888;
    padding: 4px 8px;
    text-align: right;
    font-size: 18px;
    font-family: 'Courier New', monospace;
    margin: 0 4px 6px;
    min-height: 28px;
    overflow: hidden;
  }

  .calc__top__row {
    display: flex;
    gap: 2px;
    margin: 0 4px 2px;
    justify-content: flex-end;
  }
  .calc__row {
    display: flex;
    gap: 2px;
    margin: 0 4px 2px;
  }
  .calc__btn {
    flex: 1;
    height: 26px;
    border: 1px solid #999;
    border-radius: 0;
    background: linear-gradient(to bottom, #f5f5f0, #ddd);
    font-family: Tahoma, sans-serif;
    font-size: 11px;
    cursor: pointer;
    &:hover { background: linear-gradient(to bottom, #e8e8e0, #ccc); }
    &:active { background: #bbb; }
    &--num { background: linear-gradient(to bottom, #fff, #e8e8e8); font-weight: bold; }
    &--op { color: #cc0000; }
    &--wide { font-size: 9px; }
  }
`;

export default Calculator;
